 const testimonials = [
    {
      name: "Rahul Mehta",
      company: "Mehta Industries",
      feedback:
        "JB Corporation delivered high-quality products on time. Their attention to detail and professionalism is impressive.",
    },
    {
      name: "Priya Patel",
      company: "Patel Engineering",
      feedback:
        "We’ve been working with JB Corporation for years — their products are durable, and their support team is exceptional.",
    },
    {
      name: "Vikram Shah",
      company: "Shah Packaging",
      feedback:
        "The JB team provided innovative solutions that improved our production efficiency. Highly recommended!",
    },
  ];

  export default testimonials;